"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listGroupItemVariant = listGroupItemVariant;
exports.default = exports.defaultProps = void 0;

var _color = _interopRequireDefault(require("@bootstrap-styled/color"));

var _hover = require("./hover");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  '$enable-hover-media-query': false
};
/**
 * @public
 * @description Basic css helper for different colored ListGroupItem components.
 * @param {boolean} enableHoverMediaQuery
 * @param {string} state
 * @param {string} background
 * @param {string} listColor
 * @returns {string}
 */

exports.defaultProps = defaultProps;

function listGroupItemVariant() {
  var enableHoverMediaQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultProps['$enable-hover-media-query'];
  var state = arguments.length > 1 ? arguments[1] : undefined;
  var background = arguments.length > 2 ? arguments[2] : undefined;
  var listColor = arguments.length > 3 ? arguments[3] : undefined;
  return "\n    & .list-group-item-".concat(state, " {\n      color: ").concat(listColor, ";\n      background-color: ").concat(background, ";\n    }\n  \n    & a.list-group-item-").concat(state, ",\n    button.list-group-item-").concat(state, " {\n      color: ").concat(listColor, ";\n  \n      .list-group-item-heading {\n        color: inherit;\n      }\n  \n      ").concat((0, _hover.hoverFocus)(enableHoverMediaQuery, "\n        color: ".concat(listColor, ";\n        background-color: ").concat((0, _color.default)(background).darken(0.05).toString(), ";\n      ")), "\n  \n      &.active {\n        ").concat((0, _hover.plainHoverFocus)(enableHoverMediaQuery, "\n          color: #fff;\n          background-color: ".concat(listColor, ";\n          border-color: ").concat(listColor, ";\n        ")), "\n      }\n    }\n  ");
}

var _default = {
  defaultProps: defaultProps,
  listGroupItemVariant: listGroupItemVariant
};
exports.default = _default;